module.exports = __webpack_public_path__ + "img/cash_management.61f8a7b5.png";